import { render, staticRenderFns } from "./SystemParameters.vue?vue&type=template&id=f208c2a8&scoped=true&"
import script from "./SystemParameters.vue?vue&type=script&lang=js&"
export * from "./SystemParameters.vue?vue&type=script&lang=js&"
import style0 from "./SystemParameters.vue?vue&type=style&index=0&id=f208c2a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f208c2a8",
  null
  
)

export default component.exports